import { useEffect, useState } from "react";
import { apiClient } from "../../lib/api-client";
import { formatBRL } from "../../lib/currency";

interface Collection {
  id: string;
  title: string;
  slug: string;
  description: string | null;
  is_bundle: number;
  bundle_price_cents: number | null;
}

export function CollectionsPage() {
  const [collections, setCollections] = useState<Collection[]>([]);

  useEffect(() => {
    apiClient.get<{ items: Collection[] }>("/public/collections").then((data) => setCollections(data.items));
  }, []);

  return (
    <div>
      <h1>Coleções</h1>
      <div className="grid-cards">
        {collections.map((collection) => (
          <div key={collection.id} className="card">
            <strong style={{ fontSize: "var(--text-lg)", fontFamily: "var(--font-serif)" }}>{collection.title}</strong>
            {collection.description && <p className="text-muted">{collection.description}</p>}
            {Boolean(collection.is_bundle) && collection.bundle_price_cents != null && (
              <p className="price-tag" style={{ fontSize: "var(--text-lg)", margin: 0 }}>{formatBRL(collection.bundle_price_cents)}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
